/** Fired on window when section paging starts moving to a new screen (see useSectionPaging). */
export const pageEvent = 'ua:page'

export type PageEventDetail = {
  /** The scroll position the page is moving to. */
  target: number
}
